// extracted by mini-css-extract-plugin
export default {"slide":"Slide_slide__ZaJBN","overlay":"Slide_overlay__1z4K4","text_container":"Slide_text_container__IaggL","label":"Slide_label__6runp","action_btn":"Slide_action_btn__nIgz-"};